export default "__VITE_ASSET__1f403838__"